import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App.js";
import { loadFrontendConfig } from "./common/api/config.js";
import { AuthProvider } from "./common/auth/AuthProvider.js";
import { StatusScreen } from "./common/components/StatusScreen.js";
import { createQueryClient } from "./common/query/queryClient.js";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Wurzelelement #root fehlt.");
}

const root = createRoot(container);

// Erst die Konfiguration vom Server, dann zeichnen: Aussteller und Client-Id der
// Anmeldung stehen nicht in der Oberfläche, damit dasselbe Image unter jeder Domain
// läuft. Ohne sie käme niemand bis zum Anmeldefenster — dann lieber ehrlich sagen,
// dass der Server nicht erreichbar ist.
try {
  await loadFrontendConfig();
  root.render(
    <StrictMode>
      <QueryClientProvider client={createQueryClient()}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
} catch (error) {
  root.render(
    <StatusScreen
      title="buma ist gerade nicht erreichbar"
      description={error instanceof Error ? error.message : String(error)}
    />,
  );
}
